import { jsx as e, jsxs as f } from "react/jsx-runtime";
import { cn as r } from "./designsystem-ui-react47.js";
import { isValidElement as J, cloneElement as K } from "react";
import { Tag as S } from "./designsystem-ui-react41.js";
import { Link as p } from "./designsystem-ui-react22.js";
const o = (l, d, s = !1) => typeof l > "u" ? "" : typeof l == "string" && s ? l : typeof l == "object" ? l[d] ?? "" : "";
function L({
  title: l,
  description: d,
  image: s,
  imageAlt: j,
  backgroundColor: g = "transparent",
  isImageFlipped: k = !1,
  tags: u,
  defaultTagVariant: w = "base",
  defaultTagProps: y,
  className: n,
  linkComponent: b = "a",
  headingLevel: z = "h2",
  // New button props
  primaryCtaLabel: h,
  primaryCtaHref: $,
  onPrimaryCtaClick: C,
  secondaryCtaLabel: m,
  secondaryCtaHref: E,
  onSecondaryCtaClick: N,
  // Legacy props (for backward compatibility)
  href: P,
  ctaLabel: x,
  onCtaClick: T,
  buttonVariant: V = "secondary",
  ...A
}) {
  const H = g !== "transparent", q = {
    white: "bg-surface-default",
    transparent: "bg-base-transparent"
  }[g], v = r(
    // Colors
    "text-button-primary-text bg-button-primary-bg fill-button-primary-text",
    // Border
    "border-button-primary-bg",
    // Hover
    "hover:bg-button-primary-bg-hover hover:border-button-primary-bg-hover"
  ), B = r(
    // Colors
    "text-button-secondary-text bg-button-secondary-bg fill-button-secondary-text",
    // Border
    "border-button-secondary-border",
    // Hover
    "hover:bg-button-secondary-bg-hover hover:border-button-secondary-border"
  ), D = {
    primary: v,
    secondary: B
  }[V], F = () => !u || u.length === 0 ? null : /* @__PURE__ */ e("div", { className: r("flex gap-x-2", o(n, "tags")), children: u.map((t, i) => {
    if (!t)
      return null;
    if (J(t))
      return K(t, { key: `tag-${i}` });
    if (typeof t == "string")
      return /* @__PURE__ */ e(S, { variant: w, ...y || {}, children: t }, `tag-${i}`);
    const { text: c, ...a } = t;
    return /* @__PURE__ */ e(S, { ...y || {}, ...a, children: c }, `tag-${i}`);
  }) }), G = () => {
    const t = !!h, i = !!m, c = !!x && !t && !i;
    if (!t && !i && !c)
      return null;
    const a = r(
      "text-base px-button-regular-padding-x py-button-regular-padding-y [&>svg]:w-[20px] [&>svg]:h-[20px] [&>svg]:-m-1",
      // focus
      "focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none",
      // Disabled
      "disabled:text-ink-disabled disabled:border-button-disabled-bg disabled:bg-button-disabled-bg disabled:cursor-not-allowed disabled:no-underline [&>svg]:disabled:fill-ink-disabled",
      // Base
      "cursor-pointer leading-none border-2 no-underline rounded-button inline-flex justify-center items-center gap-x-2"
    );
    return /* @__PURE__ */ f("div", { className: r("flex gap-x-3 items-center", o(n, "buttons")), children: [
      c ? /* @__PURE__ */ e(
        p,
        {
          as: b,
          className: r(a, D, o(n, "cta")),
          href: P,
          onClick: T,
          children: x
        }
      ) : null,
      i ? /* @__PURE__ */ e(
        p,
        {
          as: b,
          className: r(a, B, o(n, "secondaryButton")),
          href: E,
          onClick: N,
          children: m
        }
      ) : null,
      t ? /* @__PURE__ */ e(
        p,
        {
          as: b,
          className: r(a, v, o(n, "primaryButton")),
          href: $,
          onClick: C,
          children: h
        }
      ) : null
    ] });
  }, I = z;
  return /* @__PURE__ */ e(
    "article",
    {
      className: r("rounded-card-lg overflow-clip @container", q, o(n, "container", !0)),
      ...A,
      children: /* @__PURE__ */ f("div", { className: r("grid grid-cols-12 gap-5 size-full ring "), children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: r(
              "col-span-full aspect-video @xl:col-span-6 size-full relative bg-base-50",
              k ? "@xl:order-1" : "order-0",
              !H && "rounded-card-lg overflow-clip",
              o(n, "image")
            ),
            children: typeof s == "string" ? /* @__PURE__ */ e("img", { alt: j, className: "size-full inset-0 absolute object-cover", src: s }) : /* @__PURE__ */ e("div", { className: "w-full h-full", children: s })
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: r(
              "flex col-span-full @xl:col-span-6 flex-col gap-4 items-start justify-center",
              o(n, "content")
            ),
            children: /* @__PURE__ */ f("div", { className: "p-4 @2xl:p-10 space-y-8", children: [
              l ? /* @__PURE__ */ e(
                I,
                {
                  className: r(
                    "text-2xl text-ink-brand-default m-0 line-clamp-2 @xl:line-clamp-3",
                    o(n, "title")
                  ),
                  children: /* @__PURE__ */ e("strong", { children: l })
                }
              ) : null,
              F(),
              d ? /* @__PURE__ */ e("div", { className: r("line-clamp-2 @xl:line-clamp-4", o(n, "description")), children: d }) : null,
              G()
            ] })
          }
        )
      ] })
    }
  );
}
L.displayName = "SectionCard";
export {
  L as SectionCard
};
